import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { ClaimDocumentService } from 'src/app/core/services/claim_document.service';
import { KycService } from 'src/app/core/services/kyc.service';
import { PersonalDocumentService } from 'src/app/core/services/personal_document.service';
import { UserService } from 'src/app/core/services/user.service';
import { BaseKycProviderComponent } from '../base-kyc-provider.component';
import { KycDataService } from 'src/app/modules/client/pages/guide/services/kyc-data.service';

@Component({
  selector: 'app-thirdfort-kyc-provider',
  templateUrl: './thirdfort-kyc-provider.component.html',
  styleUrls: ['./thirdfort-kyc-provider.component.scss'],
})
export class ThirdfortKycProviderComponent extends BaseKycProviderComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    dialog: MatDialog,
    pds: PersonalDocumentService,
    cds: ClaimDocumentService,
    ks: KycService,
    us: UserService,
    dialogRef: MatDialogRef<ThirdfortKycProviderComponent>,
    kycService: KycDataService
  ) {
    const serviceData = kycService.getData();
    if (serviceData != null) {
      data = serviceData;
    }
    super(data, dialog, pds, cds, ks, us, dialogRef, kycService);
    if (!data.provider) data.provider = 'thirdfort';
  }
}
